var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list"},[_c('div',{staticClass:"list-view"},[_c('products-product',{attrs:{"products":this.$root.products}})],1),_c('BottomNavBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }